/* Copy for message cards when a prospect has declined an InMail invite with no comment */
export const DeclinedMessage = () => (
	<>
		<strong>Declined</strong> - This prospect has declined communications
	</>
);
